const formElementsRegistry = new Set();

export function registerFormElement(type) {
  formElementsRegistry.add(type);
}

export function isFormElement({ type }) {
  return formElementsRegistry.has(type);
}
